export const GET_SEGMENT = 'GET_SEGMENT';
export const LOADING_SEGMENT = 'LOADING_SEGMENT';
export const GET_CLIMA_Funcional_PuestoXUnidad_Organizativa = 'GET_CLIMA_Funcional_PuestoXUnidad_Organizativa';
export const LOADING_CLIMA_Funcional_PuestoXUnidad_Organizativa = 'LOADING_CLIMA_Funcional_PuestoXUnidad_Organizativa';
export const GET_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion = 'GET_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion';
export const LOADING_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion = 'LOADING_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion';
export const SAVE_LOADER_SEGMENT = 'SAVE_LOADER_SEGMENT'
export const FORM_SEGMENT_FAIL          =    'FORM_SEGMENT_FAIL';
export const GET_SEGMENT_EMPLOYEES = 'GET_SEGMENT_EMPLOYEES';
export const LOADING_SEGMENT_EMPLOYEES = 'LOADING_SEGMENT_EMPLOYEES';